import Required from "../Required";
import Center from "../Base/Center";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import { useFormContext } from "react-hook-form";
import useZipcodeApiQuery from "@/shared/queries/zipcode/useZipcodeApiQuery";
import { useSetPosOrderUser } from "@/shared/atoms/usePosOrderUser";
import { defaultOrderUserFormValues } from "../OrderUser/constant";

type Props = {
  isCustomerPending: boolean;
  onClickSearch: () => void;
};

const FormOrderUserActions = ({ isCustomerPending, onClickSearch }: Props) => {
  const { t } = useTranslation();
  const { isDutch } = useCountryConfigHook();
  const { reset, getValues } = useFormContext();
  const values = getValues();
  const { zip_code, house_number } = values.order_user ?? {};
  const setOrderUser = useSetPosOrderUser();
  const query = useZipcodeApiQuery(zip_code, house_number);

  return (
    <div className="mt-8 flex flex-col items-center justify-between  md:flex-row">
      <Required mr="auto" label="Required" />
      <Center className="gap-4">
        {zip_code && house_number && isDutch && (
          <span
            onClick={() => query.refetch()}
            className="font-semibold text-orange text-3xl cursor-pointer underline"
          >
            {t("posOrders.receiveData")}
          </span>
        )}
        <span
          onClick={() => {
            reset();
            setOrderUser(defaultOrderUserFormValues);
          }}
          className="font-semibold text-primary text-3xl cursor-pointer underline"
        >
          {t("posOrders.resetFields")}
        </span>
        <Button
          onClick={onClickSearch}
          type="button"
          variant="secondary"
          isPending={isCustomerPending}
        >
          {t("posOrders.search")}
        </Button>
        <Button>{t("posOrders.save")}</Button>
      </Center>
    </div>
  );
};

export default FormOrderUserActions;
